window.FLAGS = {
 
Afghanistan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Afghanistan.png?v=1730383247",
Albanien: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Albanien_b250a445-38cf-4bec-9413-7e77d8cf5b21.png?v=1730383247",
Algeriet: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Algerien.png?v=1730383246",
Andorra: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Andorra_7a3295d0-4faa-4269-ab4c-f9613ff00395.png?v=1730383247",
Argentina: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Argentina_a6050d0a-824b-4e24-a6f0-59d35045ad7e.png?v=1730383247",
Armenien: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Armenien_fd421108-0938-4e26-b8ab-df342ad55fb7.png?v=1730383246",
Assyrien: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Assyrians.png?v=1730383247",
Australien: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Australien_e66a5fc1-967b-4240-8a69-99930b724644.png?v=1730383246",
Azerbaijan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Azerbaijan_5a01ee36-80f0-45b8-9802-f61a91bb17d1.png?v=1730383246",
Bangladesh: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Bangladesh_dec0cb8e-f456-4e64-9bd6-af4f9209596d.png?v=1730383247",
Belgien: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Belgien_4815d10d-f7f0-4496-81b2-957da3728eac.png?v=1730383246",
Bolivia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Bolivien.png?v=1730383247",
Bosnien: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Bosnien.png?v=1730383247",
Bosnien_Ljiljan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Bosnien_gamla.png?v=1730383247",
Brasilien: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Brazilien.png?v=1730383247",
Bulgarien: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Bulgarien_6efc75c0-5101-48f7-aa7f-6293e0ef8acf.png?v=1730383246",
Burundi: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Burundi_720126a2-0e72-482e-b68f-9ce971105464.png?v=1765534637",
Cameroon: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Cameroon.png?v=1730383246",
Canada: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kanada_a9d8ad5d-458d-4eea-9a43-1b06d2f2319f.png?v=1730383247",
Chile: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Chile_ae6c0c91-c7ae-4422-97df-eca51aa3488a.png?v=1730383245",
China: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kina_5752aba2-55c0-4892-ba65-1ab7bfaf7ece.png?v=1730383246",
Colombia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Colombien.png?v=1730383247",
Costa_Rica: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Costa_Rica.png?v=1730383246",
Croatia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kroatien.png?v=1730383248",
Cuba: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kuba_3d429a6b-1426-4344-832f-bb78786622b8.png?v=1730383246",
Cyprus: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Cyprien.png?v=1730383246",
Demokratiska_Republiken_Kongo: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Demokratiska_Republiken_Kongo_a2eba8f0-7ed5-4188-88f5-4b74a8e28cc7.png?v=1773129838",
Denmark: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Danmark_6c5cdf90-1ad2-43eb-8bab-d26fe75a2d44.png?v=1730383246",
Djibouti: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Djibouti_9b94082f-2e11-4876-8b88-2cbecbfea207.png?v=1773517337",
Ecuador: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Ecuador_5ff59380-c8c0-40c7-ac81-85d4f0939158.png?v=1730383248",
Egypt: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Egypten.png?v=1730383247",
El_Salvador: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/El_Salvador.png?v=1730383247",
Estonia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Estland_f591d426-22cb-43b4-8284-0a2cc959bf31.png?v=1730383246",
Eritrea: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Eritrea_1f19e942-6ea7-41d7-a259-4794068e1a83.png?v=1730383247",
Ethiopia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Etiopien_0e6c3bf4-6f94-4713-b167-12fdfb4d24ae.png?v=1730383247",
Finland: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Finland_b57ea0a7-a316-43b4-8487-f46d67e1a882.png?v=1730383246",
France: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/France.png?v=1730383246",
Franska_Guyana: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Franska_Guyana.png?v=1765023896",
Gabon: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Gabon_5a8d1c14-5190-4c6e-a325-f51947c3408c.png?v=1730383245",
Gambia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Gambia_3fa6dc30-e0e4-472a-a43f-381610721b5e.png?v=1730383247",
Georgia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Georgia.png?v=1730383247",
Germany: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Tyskland.png?v=1730383247",
Ghana: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Ghana_778ff2a0-df76-4226-bc19-a48bc2e0a346.png?v=1730383246",
Greece: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Grekland.png?v=1730383247",
Guinea: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Guinea_d134db08-ab58-4ac2-a71e-eb3105087800.png?v=1730383247",
Guatemala: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Guatemala_b9abaf9f-f676-4100-a142-a72571c2b229.png?v=1765534637",
Iceland: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Island_5d24aaca-9f7c-4e31-b1b9-390ffd13f02c.png?v=1730383246",
India: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Indien_464f0f1b-8593-4273-95fb-ba11135198f6.png?v=1730383247",
Iran_Variant: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Iran.png?v=1730383247",
Iran: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Iran_ocksa_en_san_annan.png?v=1730383247",
Iraq: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Irak_en_san_annan.png?v=1730383246",
Iraq_Variant: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Irak.png?v=1730383246",
Ireland: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Irland_29b2e6cc-3930-4e7f-b57d-18408ce40161.png?v=1730383246",
Italy: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Italien_130d826a-b212-4916-96ef-50979cc3e889.png?v=1730383246",
Ivory_Coast: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Elfenbenskusten_db146128-30dd-45c8-90a2-24166d43749d.png?v=1730383246",
Jamaica: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Jamaica_06d553ab-7223-46da-acae-d47372446f04.png?v=1730383246",
Japan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Japan_7e3b0ab3-be79-4769-a901-9e2eb8207181.png?v=1730383246",
Jordan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Jordanien_496bd5e4-b861-4d3c-9097-b7107fa9faad.png?v=1730383246",
Kazakhstan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kazakhstan_cb45bd6a-d66f-47e4-a835-c125784fc710.png?v=1730383247",
Kenya: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kenya_2da53624-9157-4de2-b548-73d784d48d7d.png?v=1730383246",
Kosovo: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kosovo.png?v=1730383246",
Kurdistan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kurdistan.png?v=1730383247",
Kuwait: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kuwait_eab7e2d6-b3ee-4b08-b996-ba5851f1457b.png?v=1730383247",
Latvia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Lettland_515f73d3-d14d-49b1-8012-06027913a942.png?v=1730383247",
Lebanon: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Lebanon.png?v=1730383247",
Libya: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Libya.png?v=1730383246",
Lithuania: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Litauen_d6df7a9b-3d84-48a7-a0ab-984ad200612f.png?v=1730383246",
Macedonia_old: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Makedonien.png?v=1730383247",
Montenegro: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Montenegro.png?v=1730383247",
Morocco: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Morocco.png?v=1730383247",
North_Macedonia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Nordmakedonien.png?v=1730383247",
Norway: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Norge_f283e4fe-f9e6-465b-8ca0-0e5809165b3e.png?v=1730383246",
Pakistan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Pakistan.png?v=1730383247",
Palestine: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Palestina.png?v=1730383247",
Paraguay: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Paraguay.png?v=1730383247",
Peru: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Peru_79c40949-d417-4882-9b95-5aad2c385b75.png?v=1730383246",
Poland: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Polen.png?v=1730383246",
Portugal: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Portugal.png?v=1730383248",
Qatar: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Qatar_cf2e8100-dca9-4471-8256-04cf512fb4fc.png?v=1730383246",
Romania: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Rumanien_5699f48f-258a-47d4-b929-ba34bb880034.png?v=1730383245",
Romani: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Romani_0c1e4a8f-acf1-4067-bea3-628ec20bb0b1.png?v=1730383247",
Russia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Ryssland_71682e05-e58c-4a97-8e6b-4aebf55ea8eb.png?v=1730383246",
Sandzak: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Sandzak_fd02c6ab-15a9-487c-a889-42e9960384fd.png?v=1730383247",
Saudi_Arabia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Saudiarabien_92e3f02c-6e3f-4006-9368-1f5f261a7b90.png?v=1730383247",
Serbia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Serbien.png?v=1730383248",
Slovakia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Slovakien.png?v=1730383247",
Slovenia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Slovenien.png?v=1730383247",
Somalia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Somalien.png?v=1730383247",
South_Africa: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Sydafrika_53f96332-89b7-4e27-91af-96207cdaf775.png?v=1730383247",
Spain: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Spanien.png?v=1730383247",
Sri_Lanka: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Sri_Lanka_f23deeab-09b2-4164-87e7-a4fba7406495.png?v=1738438433",
Sweden: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Sverige.png?v=1730383246",
Syria_red: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Syrien.png?v=1730383307",
Syria_green: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Syrien_grona_gamla.png?v=1730404979",
Syriac: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Syrianska_5e8cf950-4ea5-49ad-b037-8efe61338777.png?v=1730383247",
Tunisia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Tunisien_68183812-0daa-48ae-9cc1-a2ec2a466aeb.png?v=1730383247",
Turkey: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Turkiet.png?v=1730383247",
Ukraine: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Ukraina.png?v=1730383247",
United_Kingdom: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Storbritannien.png?v=1730383247",
Ungern: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Ungern_4ad9eaba-930b-435c-85df-b7777dc18849.png?v=1730411494",
Uruguay: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Uruguay.png?v=1730383247",
USA: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/USA.png?v=1730383247",
Uzbekistan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Uzbekistan_75a5a128-e5bc-4958-807d-54b9c9cd6ec0.png?v=1730383247",
Venezuela: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Venezuela.png?v=1730383247",
Vietnam: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Vietnam_9b3b403b-3ac3-46b1-9a6f-f9c8e90c4ad2.png?v=1730383247",
Yemen: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Yemen.png?v=1730383246",
Yezidi: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Yezidi_f98d19a6-c4ed-4731-a9ad-9dd7dc0abf7c.png?v=1765534637",
Yugoslavia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Yugoslavien.png?v=1730383246",
Zimbabwe: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Zimbabwe.png?v=1730383247",
Chechnya: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Chechnya_d03fbc88-7433-47ad-a0c7-d9563a6e75c6.png?v=1730411494",
Philippines: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Fillipinerna.png?v=1730411494",
United_Arab_Emirates: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Forenade_Emiraterna.png?v=1730411493",
Malaysia: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Malaysien.png?v=1730411494",
Mexico: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Mexico_44f41488-bc30-4d1f-b8e3-9ff433735064.png?v=1730411494",
Moldova: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Moldavien_875deb42-b9ad-4800-8df8-150d9ea63f47.png?v=1730411494",
Netherlands: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Nederlanderna_cd1ca8a5-6762-4605-97a7-9f0c4fa45c6d.png?v=1730411493",
Nepal: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Nepal_269a06cb-787a-4441-b003-3ad37d5362c7.png?v=1730411494",
Niger: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Niger_fad33224-8c8b-4695-81bf-c54cf644e812.png?v=1730411493",
Nigeria: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Nigeria_89cd1507-4bc6-41f3-bdf5-6892334039a0.png?v=1730411493",
New_Zealand: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Nya_Zealand.png?v=1730411493",
Austria: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Osterrike.png?v=1730411493",
Puerto_Rico: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Puerto_Rico.png?v=1730411493",
Senegal: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Senegal_50fc07c0-e4c6-49e2-a665-bd4faaa15f5a.png?v=1730411494",
Singapore: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Singapore_108b3385-3a54-4dc5-a032-63400e3f424f.png?v=1730411493",
Somaliland: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Somaliland_7c299148-52f7-4cf3-a4a1-ae8d13e6ad77.png?v=1730411493",
United_Kingdom: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Storbritannien_c6a5b5d5-3ee9-41e1-b567-79e0a128426b.png?v=1730411494",
Sudan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Sudan_d33ebc40-e3f9-4854-b1dd-e0ff6a24f9cf.png?v=1730411494",
South_Korea: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Sydkorea_411a84b0-e8b0-4c3f-8450-765db9f84a98.png?v=1730411494",
South_Sudan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Sydsudan_78a03217-3f8c-474d-a342-c3592f824cac.png?v=1730411494",
Tanzania: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Tanzania_76961145-56fe-4bdd-b542-7689826ec22d.png?v=1730411493",
Thailand: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Thailand_9d765981-d7ce-4eed-80d6-fc522e3ba298.png?v=1730411493",
Trinidad_och_Tobago : "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/11svg_edited_flaggor.png?v=1770105399",
Czech_Republic: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Tjeckien_2c762469-1568-4d01-890b-55658347e43f.png?v=1730411494",
Turkmenistan: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Turkmenistan_2d877c0b-4621-4ced-8c74-096b2974795b.png?v=1730411494",
Uganda: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Uganda_ccf30dce-461f-4ea7-9ac9-2e1516ea8361.png?v=1730411494",
USA: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Usa_6f5b4800-2c76-4fbf-b15c-612762fc12c4.png?v=1730411494",
Venezuela: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Venezuela_256ca4ce-7f0e-48ac-b5ec-20b23286fa75.png?v=1730411494",
Belarus: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Vitryssland_081a958f-d1e5-4fb8-ad2b-8d767799594a.png?v=1730411493",
Wales: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Wales_37819e45-05c8-41e7-bf4c-03e425d4573b.png?v=1731603533",
Skottland: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Skottland.png?v=1731603530",
Skane: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Skanska_flaggan_b064d2f2-6b84-4241-bce7-9f8a5894b412.png?v=1765534636",
Nordirland: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Nordirland_64a6dbe3-bdff-4f9b-a14e-88ad1309874a.png?v=1731603530",
England: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/England_ea9613f8-3678-4cf4-b532-bcb7605861c1.png?v=1731603527",
Kanarieoarna: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Kanarieoarna_flagga.png?v=1731603531",
Sierra_Leone: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Sierra_Leone.png?v=1731411279",
Syrian_turkmen: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Syrian_Turkmen.png?v=1735906520",
Keldanska:  "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/kaldeiska.png?v=1736458899",
Mongoliet:  "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Mongoliet.png?v=1738184539",
Dominican_Republic: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Dominican_republic.png?v=1776535738",
Angola: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Angola_ea0d7b5c-97cb-42d2-92e8-b46e0e632e88.png?v=1776537895",
Nicaragua: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Nicaragua_5ef44f08-6cca-4c96-84c5-579c4a2c5a42.png?v=1776595496",
Rwanda: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Rwanda_2c8d8fd3-ba76-42e9-b436-6744584ca745.png?v=1776595906",
Switzerland: "https://cdn.shopify.com/s/files/1/0828/7584/2900/files/Switzerland.png?v=1777374665"

};

window.COUNTRIES = [
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Albanien", label: "Albanien" },
  { value: "Algeriet", label: "Algeriet" },
  { value: "Andorra", label: "Andorra" },
  { value: "Angola", label: "Angola" },
  { value: "Argentina", label: "Argentina" },
  { value: "Armenien", label: "Armenien" },
  { value: "Assyrien", label: "Assyriska" },
  { value: "Australien", label: "Australien" },
  { value: "Azerbaijan", label: "Azerbaijan" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Belgien", label: "Belgien" },
  { value: "Bolivia", label: "Bolivia" },
  { value: "Bosnien", label: "Bosnien" },
  { value: "Bosnien_Ljiljan", label: "Bosnien (Ljiljan/1992 - 1998)" },
  { value: "Brasilien", label: "Brasilien" },
  { value: "Bulgarien", label: "Bulgarien" },
  { value: "Burundi", label: "Burundi" },
  { value: "Chechnya", label: "Chechnya" },
  { value: "Chile", label: "Chile" },
  { value: "Colombia", label: "Colombia" },
  { value: "Costa_Rica", label: "Costa Rica" },
  { value: "Cyprus", label: "Cypern" },
  { value: "Demokratiska_Republiken_Kongo", label: "Demokratiska Republiken Kongo" },
  { value: "Denmark", label: "Danmark" },
  { value: "Djibouti", label: "Djibouti" },
  { value: "Dominican_Republic", label: "Dominikanska Republiken"},
  { value: "Ecuador", label: "Ecuador" },
  { value: "Egypt", label: "Egypten" },
  { value: "El_Salvador", label: "El Salvador" },
  { value: "Ivory_Coast", label: "Elfenbenskusten" },
  { value: "England", label: "England" },
  { value: "Eritrea", label: "Eritrea" },
  { value: "Estonia", label: "Estland" },
  { value: "Ethiopia", label: "Etiopien" },
  { value: "Philippines", label: "Filippinerna" },
  { value: "Finland", label: "Finland" },
  { value: "United_Arab_Emirates", label: "Förenade Arabemiraten" },
  { value: "France", label: "Frankrike" },
  { value: "Franska_Guyana", label: "Franska Guyana" },
  { value: "Gabon", label: "Gabon" },
  { value: "Gambia", label: "Gambia" },
  { value: "Georgia", label: "Georgien" },
  { value: "Ghana", label: "Ghana" },
  { value: "Greece", label: "Grekland" },
  { value: "Guinea", label: "Guinea" },
  { value: "Guatemala", label: "Guatemala" },
  { value: "India", label: "Indien" },
  { value: "Iraq", label: "Irak" },
  { value: "Iraq_Variant", label: "Irak (1991-2004)" },
  { value: "Iran", label: "Iran" },
  { value: "Iran_Variant", label: "Iran (gamla/med lejonet)" },
  { value: "Ireland", label: "Irland" },
  { value: "Iceland", label: "Island" },
  { value: "Italy", label: "Italien" },
  { value: "Jamaica", label: "Jamaica" },
  { value: "Japan", label: "Japan" },
  { value: "Yemen", label: "Jemen" },
  { value: "Yezidi", label: "Yezidi" },
  { value: "Jordan", label: "Jordanien" },
  { value: "Yugoslavia", label: "Jugoslavien" },
  { value: "Keldanska", label: "Keldanska" },
  { value: "Cameroon", label: "Kamerun" },
  { value: "Canada", label: "Kanada" },
  { value: "Kanarieoarna", label: "Kanarieöarna" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Kenya", label: "Kenya" },
  { value: "China", label: "Kina" },
  { value: "Kosovo", label: "Kosovo" },
  { value: "Croatia", label: "Kroatien" },
  { value: "Cuba", label: "Kuba" },
  { value: "Kurdistan", label: "Kurdistan" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Latvia", label: "Lettland" },
  { value: "Lebanon", label: "Libanon" },
  { value: "Libya", label: "Libyen" },
  { value: "Lithuania", label: "Litauen" },
  { value: "Macedonia_old", label: "Makedonien (1992 - 1995)" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Morocco", label: "Marocko" },
  { value: "Mexico", label: "Mexico" },
  { value: "Moldova", label: "Moldavien" },
  { value: "Mongoliet", label: "Mongoliet" },
  { value: "Montenegro", label: "Montenegro" },
  { value: "Netherlands", label: "Nederländerna" },
  { value: "Nepal", label: "Nepal" },
  { value: "Nicaragua", label: "Nicaragua" },
  { value: "Niger", label: "Niger" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "Nordirland", label: "Nordirland" },
  { value: "North_Macedonia", label: "Nord Makedonien" },
  { value: "Norway", label: "Norge" },
  { value: "New_Zealand", label: "Nya Zeeland" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Palestine", label: "Palestina" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Peru", label: "Peru" },
  { value: "Poland", label: "Polen" },
  { value: "Portugal", label: "Portugal" },
  { value: "Puerto_Rico", label: "Puerto Rico" },
  { value: "Qatar", label: "Qatar" },
  { value: "Romani", label: "Romska" },
  { value: "Romania", label: "Rumänien" },
  { value: "Russia", label: "Ryssland" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "Sandzak", label: "Sandzak" },
  { value: "Saudi_Arabia", label: "Saudiarabien" },
  { value: "Switzerland", label: "Schweiz" },
  { value: "Senegal", label: "Senegal" },
  { value: "Serbia", label: "Serbien" },
  { value: "Sierra_Leone", label: "Sierra Leone" },
  { value: "Singapore", label: "Singapore" },
  { value: "Skottland", label: "Skottland" },
  { value: "Skane", label: "Skåne" },
  { value: "Slovakia", label: "Slovakien" },
  { value: "Slovenia", label: "Slovenien" },
  { value: "Somalia", label: "Somalia" },
  { value: "Somaliland", label: "Somaliland" },
  { value: "Spain", label: "Spanien" },
  { value: "United_Kingdom", label: "Storbritannien" },
  { value: "Sudan", label: "Sudan" },
  { value: "Sri_Lanka", label: "Sri Lanka" },
  { value: "Sweden", label: "Sverige" },
  { value: "South_Africa", label: "Sydafrika" },
  { value: "South_Korea", label: "Sydkorea" },
  { value: "South_Sudan", label: "Sydsudan" },
  { value: "Syriac", label: "Syrianska" },
  { value: "Syria_red", label: "Syrien (röda)" },
  { value: "Syria_green", label: "Syrien (gröna)" },
  //{ value: "Syrian_turkmen", label: "Syrian Turkmen" },
  { value: "Tanzania", label: "Tanzania" },
  { value: "Thailand", label: "Thailand" },
  { value: "Czech_Republic", label: "Tjeckien" },
  { value: "Trinidad_och_Tobago", label: "Trinidad och Tobago" },
  { value: "Tunisia", label: "Tunisien" },
  { value: "Turkey", label: "Turkiet" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Germany", label: "Tyskland" },
  { value: "Uganda", label: "Uganda" },
  { value: "Ukraine", label: "Ukraina" },
  { value: "Ungern", label: "Ungern" },
  { value: "Uruguay", label: "Uruguay" },
  { value: "USA", label: "USA" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Venezuela", label: "Venezuela" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Belarus", label: "Vitryssland" },
  { value: "Wales", label: "Wales" },
  { value: "Zimbabwe", label: "Zimbabwe" },
  { value: "Austria", label: "Österrike" },
];